import { Datacenter, datadogRum } from '@datadog/browser-rum';
import { isBrowser } from '@zapier/common-utils';
import { canWriteCookieCategory } from '@zapier/cookies';

import { getCLS, getFID, getLCP } from 'web-vitals';

const DATADOG_RUM_CONFIG_DEFAULT_VALUES = {
  resourceSampleRate: 100,
  sampleRate: 10,
};

const initializeDatadogRum = config => {
  const { realUserMonitoring } = config;

  if (!config.realUserMonitoring) {
    return;
  }

  if (!config.isProduction) {
    console.info(
      '[frontend-app]: Datadog Real-User Monitoring (RUM) is configured to only run in production environments.'
    );
    return;
  }

  // See https://docs.datadoghq.com/real_user_monitoring/installation/?tab=us#initialization-parameters
  // for more information on what these individual parameters do.
  const datadogConfig = {
    clientToken: realUserMonitoring.clientToken,
    applicationId: realUserMonitoring.applicationId,
    datacenter: Datacenter.US,
    resourceSampleRate:
      realUserMonitoring.resourceSampleRate ||
      DATADOG_RUM_CONFIG_DEFAULT_VALUES.resourceSampleRate,
    sampleRate:
      realUserMonitoring.sampleRate ||
      DATADOG_RUM_CONFIG_DEFAULT_VALUES.sampleRate,
    service: config.serviceName,
    version: config.commitHash,
  };

  if (isBrowser() && canWriteCookieCategory('analytics')) {
    datadogRum.init(datadogConfig);

    // Initialize Web Vitals (CWV) tracking and send the data over to
    // Datadog. CWV tracks 3 metrics which best represent the overall quality
    // of a websites user experience. For more information on CWV, please see
    // https://web.dev/vitals/
    getCLS(cls => {
      datadogRum.addUserAction('cumulative-layout-shift', {
        cumulativeLayoutShift: cls.value,
      });
    });

    getFID(fid => {
      datadogRum.addUserAction('first-input-delay', {
        firstInputDelay: fid.value,
      });
    });

    getLCP(lcp => {
      datadogRum.addUserAction('largest-contentful-paint', {
        largestContentfulPaint: lcp.value,
      });
    });
  }
};

export default initializeDatadogRum;
